import type { NovaEvent } from '@nova/types';
import type { AppHostServiceEventOriginator } from './originator';

export const TrapLpcFocusEventType = 'trapLpcFocus' as const;

export interface TrapLpcFocusEvent extends NovaEvent<unknown> {
    originator: typeof AppHostServiceEventOriginator;
    type: typeof TrapLpcFocusEventType;
}
